export var WorkflowRules;
(function (WorkflowRules) {
    let FIELD;
    (function (FIELD) {
        FIELD["BOOKING_STATUS"] = "BOOKING_STATUS";
        FIELD["RESPONDENT_STATUS"] = "RESPONDENT_STATUS";
        FIELD["SURVEY_STATUS"] = "SURVEY_STATUS";
    })(FIELD = WorkflowRules.FIELD || (WorkflowRules.FIELD = {}));
    let OPERATOR;
    (function (OPERATOR) {
        OPERATOR["EQUAL"] = "EQUAL";
        OPERATOR["NOT_EQUAL"] = "NOT_EQUAL";
        OPERATOR["GREATER_THAN"] = "GREATER_THAN";
        OPERATOR["LESS_THAN"] = "LESS_THAN";
        OPERATOR["IN"] = "IN";
        OPERATOR["NOT_IN"] = "NOT_IN";
        OPERATOR["CONTAINS"] = "CONTAINS";
    })(OPERATOR = WorkflowRules.OPERATOR || (WorkflowRules.OPERATOR = {}));
    let DATA_TYPE;
    (function (DATA_TYPE) {
        DATA_TYPE["STRING"] = "STRING";
        DATA_TYPE["NUMBER"] = "NUMBER";
        DATA_TYPE["OBJECT"] = "OBJECT";
    })(DATA_TYPE = WorkflowRules.DATA_TYPE || (WorkflowRules.DATA_TYPE = {}));
})(WorkflowRules || (WorkflowRules = {}));
//# sourceMappingURL=workflow.js.map